import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import themes from 'styles/themes';
export interface IIconSelect {
    selectedValue: any;
    children: any;
    onChange: (value: any) => void;
    error?: any;
}

const useStyles = makeStyles(() => ({
    selectContainer: {
        padding: '10px',
        border: (props: any) => (props.error ? '1px solid red' : '1px solid'),

        borderRadius: '10px',
        height: '40px',
        fontSize: '14px',
        background: 'transparent',
        '& svg': {
            fill: (props) => (props.error ? 'red' : themes.palette.primary.main),
        },
        '& .MuiSelect-select:focus': {
            background: 'transparent !important',
        },
    },
}));

const useOutLineStyles = makeStyles(() => ({
    notchedOutline: {
        border: 'none',
        background: 'transparent',
    },
}));

const IconSelect = (props: IIconSelect) => {
    const classes = useStyles(props);
    const outlineClasses = useOutLineStyles();
    const listMenuItem = useMemo(
        () => React.Children.map(props.children, (children) => React.cloneElement(children, {})),
        [props.children],
    );
    return (
        <Select
            value={props.selectedValue}
            inputProps={{ 'aria-label': 'Without label' }}
            className={classes.selectContainer}
            style={{
                color: props.error ? 'red' : themes.palette.primary.main,
            }}
            onChange={(e) => {
                props.onChange(e.target.value);
            }}
            input={<OutlinedInput style={{ border: 'none!important' }} classes={outlineClasses} />}
        >
            {listMenuItem}
        </Select>
    );
};

export default IconSelect;
